<template>
  <div class="course-main">
    <el-table
      ref="refTable"
      @row-click="expandRow"
      :expand-row-keys="expands"
      style="width: 100%"
      :data="data"
      :row-key='getRowKeys'
      :row-class-name="rowClassName">
      <el-table-column type="expand" >
        <template slot-scope="{row}">
          <el-form label-position="left"  label-width="110px" class="demo-table-expand" style="margin-left: 10px">
            <el-form-item label="课程基本信息">
              <div class="axj-show-club-main-announce-list">
                <el-collapse accordion class="axj-show-club-main-announce"  v-model="activeNames" @change="handleChange">
                  <el-collapse-item  name="1">
                    <template slot="title">
                      <div style="display: flex;width: 100%;">
                        <div class="course-name" style="flex: 4.6">
                          {{row.name}}
                        </div>
                        <div class="course-link"  style="flex: 2;color: #00adb5">
                          <a @click.stop="editCourseBase(row.id)">编辑</a>
                        </div>
                      </div>
                    </template>
                    <div class="course-base-list">
                      <div class="base-list-item">
                        <label>名称</label><div class="item">{{row.name}}</div>
                      </div>
                      <div class="base-list-item">
                        <label>创建时间</label><div class="item">{{ row.created_at|parseTime}}</div>
                      </div>
                      <div class="base-list-item">
                        <label>学校</label>
                        <div class="item">
                          {{ row.School.name }}
                            <el-tag size="mini">{{row.Major.name}}</el-tag>
                        </div>
                      </div>
                      <div class="base-list-item">
                        <label>简介</label><div class="item">{{ row.summary }}</div>
                      </div>
                      <div class="base-list-item">
                        <label>封面</label>
                        <div class="item image">
                          <img @click="previewWord({type:'image',url:row.thumb})" :src="preViewUrl+row.thumb">
                        </div>
                      </div>
                    </div>
                  </el-collapse-item>
                </el-collapse>
              </div>
            </el-form-item>
            <el-form-item label="课时信息">
              <div style="display: flex">
                <div style="display: flex;flex:4;flex-direction: column">
                  <div class="course-time-list" v-for="x in row.Segments">
                    <div class="time-list-item" >
                      <div class="item-dio">
                      </div>
                      <div class="week">
                        周{{x.weekday|parseWeekDay}}
                      </div>
                      <div class="docu-info">
                        第{{x.index_start}}节～第{{x.index_end}}节
                      </div>
                      <div class="address">
                        {{x.address}}
                      </div>
                    </div>
                  </div>
                </div>
                <div class="edit" style="flex:2;color: #00adb5;cursor: pointer">
                  <a @click="editCourseTime(row.id)">编辑</a>
                </div>
              </div>
            </el-form-item>
            <el-form-item label="上传资料">
              <div class="course-file-list">
                <div class="file-list-item">
                  <label>
                    课程大纲
                  </label>
                  <div class="item">
                                      <ul v-if="row.outline_url!=''" @click="previewWord({type:row.outline_type,url:row.outline_url})" class="el-upload-list el-upload-list--text">
                                        <li tabindex="0" class="el-upload-list__item is-success">
                                          <a class="el-upload-list__item-name">
                                            <i class="el-icon-document"></i>
                                            {{row.outline_name}}
                                          </a>
                                        </li>
                                      </ul>
                  </div>
                  <div style="flex: 1;color: #00adb5;cursor: pointer">
                    <a @click="editCourseFile(row.id)">编辑</a>
                  </div>
                </div>
                <div class="file-list-item">
                  <label>
                    课程资料
                  </label>
                  <div style="flex: 1.8">
                    <div class="item" v-for="x in attachments">
                      <ul  @click="previewWord(x)" class="el-upload-list el-upload-list--text">
                        <li tabindex="0" class="el-upload-list__item is-success">
                          <a class="el-upload-list__item-name">
                            <i class="el-icon-document"></i>
                            {{x.name}}
                          </a>
                        </li>
                      </ul>
                    </div>
                  </div>
                  <div style="flex: 1;color: #00adb5;cursor: pointer">
                    <a @click="handleCreateMaterial(row.id)">
                      编辑
                    </a>
                  </div>
                </div>
              </div>

            </el-form-item>
            <el-form-item label="互动信息">
              <div class="course-info-list">
                <div class="info-list-item">
                  <label>
                    选课人数
                  </label>
                  <div class="num">
                    {{row.select_sum}}
                  </div>
                </div>
                <div class="info-list-item">
                  <label>
                    旁听人数
                  </label>
                  <div class="num">
                    {{row.listen_sum}}
                  </div>
                </div>
                <div class="info-list-item">
                  <label>
                    关注人数
                  </label>
                  <div class="num">
                    {{row.follow_sum}}
                  </div>
                </div>
              </div>
              <div class="course-comment-list">
                <div class="comment-list-item">
                  <label>
                    课程评价
                  </label>
                  <div style="margin-left: 20px">
                    <el-tag size="mini">内容充实：{{row.grade1}}</el-tag>
                    <el-tag size="mini">生动有趣：{{ row.grade2 }}</el-tag>
                    <el-tag size="mini">讲解独到：{{row.grade3}}</el-tag>
                    <el-tag size="mini">认证负责：{{row.grade4}}</el-tag>
                  </div>
                </div>
              </div>
            </el-form-item>
          </el-form>
        </template>
      </el-table-column>
      <el-table-column label="创建时间" show-overflow-tooltip  width="140px" prop="time">
        <template slot-scope="{row}">
          {{ row.created_at|parseTime}}
        </template>
      </el-table-column>
      <el-table-column label="课程名称" show-overflow-tooltip width="160px"  prop="name"></el-table-column>
      <el-table-column label="选课人数"  width="120px" prop="select_sum">
        <template slot-scope="{row}">
          {{ row.select_sum }}
        </template>
      </el-table-column>
      <el-table-column label="旁听人数"  width="125px" prop="doSearch">
        <template slot-scope="{row}">
          {{row.listen_sum}}
        </template>
      </el-table-column>
      <el-table-column label="关注人数"  width="135px" align="center" prop="doSearch">
        <template slot-scope="{row}">
          {{ row.follow_sum }}
        </template>
      </el-table-column>
      <el-table-column  label="操作" align="center">
        <template slot-scope="{row}">
          <axj-button-v2
            button-color="bread"
            button-size="medium"
            button-icon="del1"
            @click="handleDelete(row.id)"
          ></axj-button-v2>
          <axj-button-v2
            @click="handleUpdate(row.id)"
            button-icon="edit1"
          ></axj-button-v2>
        </template>
      </el-table-column>
      <el-table-column label="作业管理" align="center" width="105px" prop="doSearch">
        <template slot-scope="{row}">
<!--          {{ row.follow_sum }}-->
          <el-button size="mini" type="primary" @click="handlePreviewHomeWork(row)" plain icon="el-icon-view"></el-button>
        </template>
      </el-table-column>
    </el-table>
    <axj-file-preview
      :show-preview.sync="preview.show"
      :preview-file-type="preview.previewFileType"
      :preview-files="preview.previewFiles"
    />
    <course-base-edit
      :course-id="courseBaseEdit.courseId"
      :show.sync="courseBaseEdit.show"
      :is-create="courseBaseEdit.create"
      @updateSuccess="handleBaseEditUploadSuccess"
    />
    <course-time-edit
      :course-id="courseTimeEdit.courseId"
      :show.sync="courseTimeEdit.show"
      :is-create="courseTimeEdit.create"
      @updateSuccess="handleTimeEditUploadSuccess"
    />
    <course-file-edit
      :course-id="courseFileEdit.courseId"
      :show.sync="courseFileEdit.show"
      :is-create="courseFileEdit.create"
      @updateSuccess="handleFileEditUploadSuccess"
    />
    <love-material-action
      :course-id="materialAction.courseId"
      :show.sync="materialAction.show"
      :is-create="materialAction.isCreate"
      @updateSuccess="handleMaterialEditUploadSuccess"
      @create="handleCreateMaterial" />
  </div>
</template>

<script>
import AxjButtonV2 from "../../../../../components/common/button/axj-button";
import AxjButton from "../../../../../components/axj-button/index";
import commonModels from '@/common/models/common-models'
import common from '@/common/common'
import {fetchAssistantCourseMaterialList} from '@/api/axj-help/axj-help-course.js'
import CourseBaseEdit from "./component/course-base-edit/index";
import CourseTimeEdit from "./component/course-time-edit/index";
import CourseFileEdit from "./component/course-file-edit/index";
import LoveMaterialAction from "./component/PageMaterialAction/index";
export default {
  name: "course-main",
  components: {LoveMaterialAction, CourseFileEdit, CourseTimeEdit, CourseBaseEdit, AxjButtonV2, AxjButton},
  props:{
    data:{
      type:Array,
      default:()=>{
        return []
      }
    }
  },
  watch:{
    data(v){

    }
  },
  methods:{

    handlePreviewHomeWork(row){
      this.$emit("previewHomeWork",row)
    },
    handleDelete(id){
      this.$emit("delete",id)
    },
    getRowKeys(row){
      return row.id
    },
    handleBaseEditUploadSuccess(){
      this.$emit("uploadSuccess")
      this.courseBaseEdit.show=false
    },
    handleTimeEditUploadSuccess(){
      this.$emit("uploadSuccess")
      this.courseTimeEdit.show=false
    },
    handleFileEditUploadSuccess(){
      this.$emit("uploadSuccess")
      this.courseFileEdit.show=false
    },
    handleMaterialEditUploadSuccess(){
      this.$emit("uploadSuccess")
      this.listCourseAttachment({id:this.expands[0]})

      //更新时间
      //用户注销
      //用户冻结
      //
      this.materialAction.show = false
    },
    handleCreateMaterial(courseId) {
      this.materialAction.courseId=courseId
      this.materialAction.content = ''
      this.materialAction.isCreate = true
      this.materialAction.show = true
    },
    editCourseFile(courseId){
      this.courseFileEdit.courseId=courseId;
      this.courseFileEdit.create=false;
      this.courseFileEdit.show=true
    },
    editCourseBase(courseId){
      this.courseBaseEdit.courseId=courseId;
      this.courseBaseEdit.create=false;
      this.courseBaseEdit.show=true
    },
    editCourseTime(courseId){
      this.courseTimeEdit.courseId=courseId;
      this.courseTimeEdit.create=false;
      this.courseTimeEdit.show=true
    },
    previewWord(x){
      if(x.type!='image'&&x.type!='word'&&x.type!='png'&&x.type!='jpg'){
        window.open(this.preViewUrl+x.url)
        return
      }

      this.preview.previewFileType=x.type
      if(x.type=='png'||x.type=='jpg'){
        this.preview.previewFileType='image'
      }
      this.preview.previewFiles=[]

      this.preview.previewFiles.push({
        url:x.url
      })
      this.preview.show=true
    },
    listCourseAttachment(row){
      fetchAssistantCourseMaterialList({
        where: JSON.stringify({
          course_id: row.id
        }),
        preload:true
      }).then(res=>{
        this.attachments=res.data.lists
      },error => {

      })
    },
    handlePlayVideo(row) {
      if(row.video_url) {
        let url = row.video_url.indexOf('http')>=0?row.video_url:this.resourcePrefix.url+row.video_url
        this.video.url = url
        this.showLovePlayer = true
      }
    },
    handleUpdate(v){
      this.$emit('update',v)
    },
    expandRow(row,index,e){
      let target=e.target
      let tempExpands=this.expands
      this.expands=[]
      if(target.className.indexOf('cell')==0||target.className.indexOf('el-tag')==0||target.className.indexOf('el-table')==0){
        if(tempExpands.indexOf(row.id)==-1){
          this.expands.push(row.id)
          this.listCourseAttachment(row)
        }else{
          this.expands.pop()
        }
        return
      }
    },
    rowClassName({row, rowIndex}){
      row.index=rowIndex
      if(rowIndex%2==0){
        return "while-row"
      }else{
        return "gray-row"
      }
    }
  },
  computed:{
    preViewUrl(){
      return this.$common.SystemConfig.PreViewUrl
    }
  },
  filters:{
    parseTime(time){
      return commonModels.formatTime(time,'Y/M/D h:m:s')
    },
    parseWeekDay(index){
      return commonModels.formatWeekDay(index)
    },
    arrayImg(v,x){
      let preViewUrl=common.SystemConfig.PreViewUrl
      let array=[]
      array.push(
        preViewUrl+x
      )
      // for (let i =0 ;i<v.length;i++){
      //   if(v[i].url===x.url){
      //     let temp=array[0]
      //     array[0]=preViewUrl+x.url
      //     array.push(temp)
      //   }else{
      //     array.push(preViewUrl+v[i].url)
      //   }
      //
      // }
      return array
    }
  },
  data(){
    return{
      materialAction: {
        id: 0,
        content: '',
        show: false,
        isCreate: true,
        courseId:undefined
      },
      courseFileEdit:{
        show:false,
        create:true,
        courseId:undefined
      },
      courseBaseEdit:{
        show:false,
        create:true,
        courseId:undefined
      },
      courseTimeEdit:{
        show:false,
        create:true,
        courseId:undefined
      },
      preview:{
        show:false,
        previewFileType:'word',
        previewFiles:[]
      },
      showLovePlayer: false,
      video: {
        url : '',
      },
      activeNames:'',
      attachments:[],
      expands: [],
    }
  }
}
</script>

<style slot-scope lang="scss">
.course-main{
  .el-tag,.el-tag--info {
    background-color: #41555d;
    /* border-color: #e9e9eb; */
    color: #ffffff;

  }
  .el-tag--mini{
    height: 20px;
    padding: 0 5px;
    line-height: 20px;
  }
  .el-table__body tr:hover>td{
    background-color: #f2f5f8 !important;
  }
  .el-table__body tr.current-row>td{
    background-color: #f2f5f8 !important;
  }
  .course-comment-list{
    .comment-list-item{
      display: flex;
    }
  }
  .course-info-list{
    display: flex;
    margin-top: 20px;
    .info-list-item{
      display: flex;
      margin-right: 20px;
      min-width: 100px;
      div{
        margin-left: 10px;
      }
    }
  }
  .course-time-list{
    display: flex;
    flex-direction: column;
    .time-list-item{
      display: flex;
      align-items: center;
      .week{
        margin-right: 20px;
      }
      .item-dio{
        width: 10px;
        height: 10px;
        margin-right: 10px;
        border-radius: 5px;
        background-color: #00adb5;
      }
      .docu-info{
        margin-right: 20px;
      }
    }
  }
  .course-file-list{
    margin-top: 20px;
    display: flex;
    flex-direction: column;
    .file-list-item{
      margin-bottom: 15px;
      display: flex;
      flex-flow: wrap;
      .item{
        flex: 1.70;
        margin-left: 25px;
      }
      .image{
        img{
          cursor: pointer;
          width: 105px;
          height: 105px;
          border-radius: 6px;
        }
      }
    }
  }
  .axj-show-club-main-announce-list{
    width: 100%;

    .axj-show-club-main-announce{
      margin-right: 10px;
      margin-top: -5px;

      .course-base-list{
        display: flex;
        flex-direction: column;
        width: 95%;
        margin-left: auto;
        .base-list-item{
          margin-bottom: 15px;
          display: flex;
          .item{
            margin-left: auto;
            width: 85%;
          }
          .image{
            img{
              cursor: pointer;
              width: 105px;
              height: 105px;
              border-radius: 6px;
            }
          }
        }
      }
    }
  }
  .axj-show-club-main-content{
    line-height: 20px;
    margin-top: 9px;
  }
  .el-table .warning-row {
    background: oldlace;
  }
  .el-table .while-row {
    background: #ffffff;
  }
  .el-table .gray-row {
    background: #e8eef0;
  }
  .el-table .success-row {
    background: #f0f9eb;
  }
  .el-table .info-row{
    background: #D6D8DC;
  }
  .axj-show-club-main-images{
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    .axj-show-club-main-dio{
      width: 126.888px;
      height: 126.888px;
      border-radius: 10px;
      margin-top: 18.26px;
      img{
        width: 100%;
        height: 100%;
        width: 126.888px;
        height: 126.888px;
        border-radius: 10px;
      }
    }
    .post-main-word{
      width: 426.888px;
      height: 26.888px;
      border-radius: 10px;
      margin-top: 18.26px;
    }
    .axj-show-club-main-image{
      width: 126.888px;
      height: 126.888px;
      border-radius: 10px;
      margin-top: 18.26px;
      .el-image{
        width: 100%;
        height: 100%;
        width: 126.888px;
        height: 126.888px;
        border-radius: 10px;
      }
    }
    .axj-show-club-main-image:not(:first-child){
      margin-left: 30.5px;
    }
    .axj-show-club-main-image:nth-child(5n+6){
      margin-left: 0px;
    }
  }

  .post-main-images{
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    .post-main-dio{
      width: 126.888px;
      height: 126.888px;
      border-radius: 10px;
      margin-top: 18.26px;
      img{
        width: 100%;
        height: 100%;
        width: 126.888px;
        height: 126.888px;
        border-radius: 10px;
      }
    }
    .post-main-word{
      width: 426.888px;
      height: 26.888px;
      border-radius: 10px;
      margin-top: 18.26px;
    }
    .post-main-image{
      width: 126.888px;
      height: 126.888px;
      border-radius: 10px;
      margin-top: 18.26px;
      .el-image{
        width: 100%;
        height: 100%;
        width: 126.888px;
        height: 126.888px;
        border-radius: 10px;
      }
      img{
        width: 100%;
        height: 100%;
        width: 126.888px;
        height: 126.888px;
        cursor: pointer;
      }
    }
    .post-main-image:not(:first-child){
      margin-left: 30.5px;
    }
    .post-main-image:nth-child(5n+6){
      margin-left: 0px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/axj-help/axj-course/component/course-main/index.vue